import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getRewardTitik(params) {
	return client.get("binary/reward/list", {
		params: params,
	});
}

function getHistoryRewardTitik(params) {
	return client.get("binary/reward/history", {
		params: params,
	});
}

function getRewardPribadi(params) {
	return client.get("binary/reward-personal/list", {
		params: params,
	});
}

function getHistoryRewardPribadi(params) {
	return client.get("binary/reward-personal/history", {
		params: params,
	});
}

function getRewardGroup(params) {
	return client.get("binary/reward-group/list", {
		params: params,
	});
}

function getHistoryRewardGroup(params) {
	return client.get("binary/reward-group/history", {
		params: params,
	});
}

function getHistoryRewardPoint(params) {
	return client.get("binary/reward/point", {
		params: params,
	});
}

export default {
	getRewardTitik,
	getRewardPribadi,
	getRewardGroup,
	getHistoryRewardTitik,
	getHistoryRewardPribadi,
	getHistoryRewardGroup,
	getHistoryRewardPoint
};